import Framework from './lib/framework/framework';

// eslint-disable-next-line @typescript-eslint/no-floating-promises
Framework.initialize();
